import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  ViewEncapsulation,
} from '@angular/core';

const HOST_SELECTOR_CLASS_PAIR = [
  {
    selector: 'ca-action-button',
    classes: ['ca-button', 'ca-button-action'],
  },
  {
    selector: 'ca-create-button',
    classes: ['ca-button', 'ca-button-create'],
  },
  {
    selector: 'ca-raised-button',
    classes: ['ca-button', 'ca-button-raised'],
  },
  {
    selector: 'large',
    classes: ['large'],
  },
  {
    selector: 'primary',
    classes: ['primary'],
  },
];

@Component({
  selector: `button[ca-raised-button], button[ca-action-button], a[ca-raised-button], a[ca-action-button], button[ca-create-button]`,
  template: '<ng-content></ng-content>',
  host: {
    '[attr.disabled]': 'disabled || null',
  },
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./button.scss'],
  standalone: false,
})
export class CaButtonComponent {
  constructor(private elementRef: ElementRef) {
    const classList = (elementRef.nativeElement as HTMLElement).classList;
    for (const pair of HOST_SELECTOR_CLASS_PAIR) {
      if (this._hasHostAttributes(pair.selector)) {
        pair.classes.forEach((className: string) => {
          classList.add(className);
        });
      }
    }
  }
  @Input()
  @HostBinding('class.selected')
  selected = false;

  private _color?: string;
  private _disabled: boolean = false;

  @Input()
  set color(value: string) {
    const colorPalette = value || 'control';

    if (colorPalette !== this._color) {
      if (this._color) {
        this.elementRef.nativeElement.classList.remove(`${this._color}`);
      }
      if (colorPalette) {
        this.elementRef.nativeElement.classList.add(`${colorPalette}`);
      }

      this._color = colorPalette;
    }
  }

  @Input()
  set disabled(value: any) {
    this._disabled = coerceBooleanProperty(value);
  }

  get disabled(): boolean {
    return this._disabled;
  }

  /** Gets whether the button has one of the given attributes. */
  private _hasHostAttributes(...attributes: string[]) {
    return attributes.some((attribute) => this.elementRef.nativeElement.hasAttribute(attribute));
  }
}
